import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ExternalLink, FilePen } from "lucide-react";
import { adminPages } from "../api";
import { Card, PageHeader, Spinner } from "../ui";

export default function PagesList() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    adminPages.list().then(setItems).catch(() => setItems([]));
  }, []);
  if (!items) return <Spinner />;
  return (
    <div data-testid="admin-pages-list">
      <PageHeader title="Pages" description="Every public page is editable. Sections, headings, body copy, images and SEO." />
      <Card className="overflow-hidden">
        <table className="min-w-full">
          <thead>
            <tr className="bg-slate-50 border-b border-slate-200">
              <Th>Title</Th><Th>Route</Th><Th>Updated</Th><Th>Actions</Th>
            </tr>
          </thead>
          <tbody>
            {items.map((p) => (
              <tr key={p.slug} className="border-b border-slate-100 hover:bg-slate-50/60">
                <Td><div className="font-semibold text-[hsl(var(--aoa-navy))]">{p.title}</div><div className="text-xs text-slate-500">{p.slug}</div></Td>
                <Td><code className="rounded bg-slate-100 px-2 py-0.5 text-xs">{p.route}</code></Td>
                <Td className="text-xs text-slate-500">{p.updated_at ? new Date(p.updated_at).toLocaleString() : "—"}</Td>
                <Td>
                  <div className="flex gap-2">
                    <Link to={`/admin/pages/${p.slug}`} data-testid={`edit-page-${p.slug}`} className="inline-flex items-center gap-1.5 rounded-lg bg-[hsl(var(--aoa-royal))] px-3 py-1.5 text-xs font-semibold text-white hover:bg-[hsl(var(--aoa-navy))]">
                      <FilePen className="h-3.5 w-3.5" /> Edit
                    </Link>
                    <a href={p.route} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-semibold text-slate-700 hover:border-[hsl(var(--aoa-royal))]">
                      <ExternalLink className="h-3.5 w-3.5" /> View
                    </a>
                  </div>
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}

const Th = ({ children }) => <th className="text-left text-xs font-semibold uppercase tracking-[0.12em] text-slate-600 px-5 py-3">{children}</th>;
const Td = ({ children, className = "" }) => <td className={`px-5 py-4 text-sm align-middle ${className}`}>{children}</td>;
